import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ITelephonyConfiguration } from '../../viewmodels/AppViewModels';

export const RESOLVE_PHONE_NUMBER_QUERY_KEY = 'resolvePhoneNumberQueryKey';

export const useResolvePhoneNumber = ({
	enabled = true,
	phoneNumberId,
}: {
	enabled?: boolean;
	phoneNumberId?: string;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<ITelephonyConfiguration>(`phoneNumber/${phoneNumberId}`, 'GET');
		},
		queryKey: [RESOLVE_PHONE_NUMBER_QUERY_KEY, phoneNumberId],
	});
};
